export function parseNumberFromUrl(value: string): number {
	const num = parseFloat(value);
	const v = value.toLowerCase();
	if (v.includes("cr")) return num * 10000000;
	if (v.includes("l")) return num * 100000;
	if (v.includes("k")) return num * 1000;
	return num;
}
